import React, { useState } from 'react'
import Page from 'src/components/Page'

import FormStep from './FormStep'
import ConfirmSmsStep from './ConfirmSmsStep'
import BankResult from './BankResult'
import FailPay from './FailPay'
import BankPortal from '../../../components/bankPortal/BankPortal'

const steps = [FormStep, ConfirmSmsStep, BankResult, FailPay, BankPortal]

const RegisterStepperView = () => {
  const [activeStep, setActiveStep] = useState(0)

  const CurrentComponent = steps[activeStep]

  return (
    <Page
      title="عضویت پنل استعدادیابی آنلاین"
      metaName="گارنت"
      metaContent="عضویت گارنت | پلتفرم استعدادیابی آنلاین"
      linkRef="canonical"
      linkHref="https://panel.garnettalent.ir/register"
    >
      <CurrentComponent setActiveStep={setActiveStep} />
    </Page>
  )
}

export default RegisterStepperView
